import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GridService } from "../shared/grid/grid.service";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { ToastService } from "./toast.service";
import {
    NotificationSettings,
    NotificationSettingsData,
} from "../models/notificationSettings.model";
import { NotificationAssignmentsModel } from "../models/notificationAssignments.model";

@Injectable({
    providedIn: "root",
})
export class NotificationSettingsService extends GridService<NotificationSettings> {
    constructor(
        http: HttpClient,
        private toastService: ToastService,
    ) {
        super("NotificationSettings", http);
    }

    getNotificationSettingsData(): Observable<NotificationSettingsData> {
        return this.http
            .get<NotificationSettingsData>(
                this.getApiUrl(
                    `${this.controllerName}/GetNotificationSettingsData`,
                ),
            )
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading notification settings data",
                        true,
                    );
                    return of(new NotificationSettingsData());
                }),
            );
    }

    getNotificationAssignments(
        id: string,
    ): Observable<NotificationAssignmentsModel> {
        return this.http
            .get<NotificationAssignmentsModel>(
                this.getApiUrl(
                    `${this.controllerName}/GetNotificationAssignments?id=${id}`,
                ),
            )
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading notification assignments",
                        true,
                    );
                    return of(new NotificationAssignmentsModel());
                }),
            );
    }

    saveNotificationAssignments(payload: NotificationAssignmentsModel) {
        return this.http.post(
            this.getApiUrl(
                `${this.controllerName}/SaveNotificationAssignments`,
            ),
            payload,
        );
    }

    clone(payload: NotificationSettings) {
        return this.http.post(
            this.getApiUrl(`${this.controllerName}/CloneNotificationSettings`),
            payload,
        );
    }
}
